<template>
  <div class="card main-content">
  <div class="progress-spinner" v-if="spinnerLoadingStatus">
      <ProgressSpinner></ProgressSpinner>
  </div>
    <div class="grid">
      <div class="sm:col-12 md:col-12 lg:col-12">
        <div class="flex justify-content-between flex-wrap mx-2">
            <div class="flex align-items-center justify-content-center">
              <label class="text-xl ">
                New Invoice
              </label>
            </div>
            <div class="flex align-items-center justify-content-center mt-1">
              <router-link to="/invoice-details" rel="noopener">
                <Button label="Invoice List" icon="pi pi-bars" size="small" raised />
              </router-link>
            </div>
        </div>
        
      </div>
    </div>

    <div class="grid nested-grid">
      <div class="sm:col-12 md:col-9 lg:col-9">
        <div class="grid">
          <div class="col-12">            
            <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 ml-2">
              <!-- <div class="mb-3"> -->
                <div class="flex justify-content-between flex-wrap mx-2">
                  <div class="flex align-items-center justify-content-center">
                    <label class="text-xl font-semibold">Invoice</label>
                  </div>
                  <div class="flex align-items-center justify-content-center">
                    <Button label="Save Invoice" icon="pi pi-save" severity="success" size="small" raised @click="saveInvoice" />
                  </div>
                </div>
              <!-- </div> -->
              <div class="formgrid grid mx-1">
                  <div class="field col">
                      <label >Invoice No.<span class="text-red-500">*</span></label>
                      <div>
                        <InputText class="w-full" v-model="invoiceNo" variant="filled" placeholder="Enter Invoice No." @change="convertToUpperCase"></InputText>
      
                      </div>
                  </div>
                  <div class="field col">
                      <label >Invoice Date<span class="text-red-500">*</span></label>
                      <div>
                        <Calendar class="w-full" v-model="invoiceDate" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" ></Calendar>
                      </div>
                  </div>
                  <div class="field col">
                      <label >Freight</label>
                      <div>
                        <InputNumber class="w-full" v-model="freight" :minFractionDigits="2" :maxFractionDigits="2" @input="calculateInvoiceValue($event)"></InputNumber>
                      </div>
                  </div>
              </div>
      
              <div>
                <Divider></Divider>
              </div>

              <!-- <div class="flex justify-content-between align-items-center mb-3">
                <label class="text-xl font-semibold">Value Summary</label>
              </div> -->
              <div class="grid mx-1">
                <div class="col-8">                      
                    <div >
                      <label class="text-xl font-semibold">Remarks</label>
                    </div>
                </div>
                <div class="col">                      
                    <div class="ml-2">
                      <label class="text-xl font-semibold">Value Summary</label>
                    </div>
                </div>
              </div>
              
              <div class="grid nested-grid">
                 <div class="col-8">
                    <Textarea class="w-full ml-2" v-model="remarks" rows="7" placeholder="Enter remarks if any"></Textarea>
                </div>
                <div class="col-4">
                  <div class="grid mx-2">
                    <div class="col-6">
                      <label class="">Taxable:</label>
                    </div>
                    <div class="col-6 text-right">
                      <label >{{ formatCurrency(taxable) }}</label>
                    </div>
                    <div class="col-6">
                      <label class="">GST:</label>
                    </div>
                    <div class="col-6 text-right">
                      <label >{{ formatCurrency(invoiceGst) }}</label>
                    </div>
                    <div class="col-6">
                      <label class="">Disc:</label>
                    </div>
                    <div class="col-6 text-right">
                      <label >{{ formatCurrency(invoiceDiscount) }}</label>
                    </div>
                    <div class="col-6">
                      <label class="">Freight:</label>
                    </div>
                    <div class="col-6 text-right">
                      <label >{{ formatCurrency(freight) }}</label>
                    </div>
                    <div class="col-6">
                      <label class="font-semibold">Total:</label>
                    </div>
                    <div class="col-6 text-right font-semibold">
                      <label >{{ formatCurrency(invoiceValue) }}</label>
                    </div>
                  </div>
                </div>
              </div>
              
      
              <div>
                <InvoiceItemTwo
                  v-for="(item, index) in items"
                  :key="index"
                  v-model="items[index]"
                  :item="item"
                  @remove="items.splice(index, 1)"
                  :visible="newItemDialog"
                  @close-dialog="closeDialog"
                  @save-item="saveItem"
                />
      
                <!-- <Button label="Add Item" icon="pi pi-plus" class="mt-4" @click="addItem" /> -->
              </div>
              
            </div>
          </div>

          <div class="col-12"> 
            <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-2 ml-2">
              <div class="mb-3">
                <label class="text-xl font-semibold">Invoice Items</label>
              </div>
              <div v-if="invoiceItems.length==0">
                <label >
                  No items added to invoice yet.
                </label>
              </div>

              <div v-if="invoiceItems.length>0">
                <ScrollPanel class="mb-5" style="width: 100%; height: 35vh">
                <div v-for="(item, index) in invoiceItems" :key="index" class="mx-2 my-2">
                  <Panel>
          
                      <div class="flex flex-wrap align-items-center justify-content-between gap-3 mb-1">
                        <div class="flex align-items-center gap-2">
                           {{ (index + 1) }}. <label class="text-lg font-semibold" >{{ item.name }}</label>
                        </div>
                        <div class="flex align-items-center gap-2">
                          <Button icon="pi pi-trash" severity="danger" text raised @click="onRowUnselect({data:{id:item.itemId}})" v-tooltip.top="'Remove Item'"></Button>
                        </div>
                      </div>              
  
                    <div class="grid">
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">HSN:</label> <label>{{ item.itemHsn }}</label>
                          </div>
                      </div>
                      <div class="col">
                        <div >
                          <label class="font-semibold">Packing:</label><label>{{ item.packing }}</label>
                        </div>
                      </div>
                      <div class="col">
                        <div >
                          <label class="font-semibold">Batch:</label><label>{{ item.itemBatch }}</label>
                        </div>
                      </div>
                      <div class="col">
                          <div >
                            <label class="font-semibold">Model No: </label><label>{{ item.modelNo }}</label>
                          </div>
                      </div>
                    </div>
  
                    <div class="grid">
                      <div class="col">                      
                          <div >
                            
                          </div>
                      </div>
                      <div class="col">
                        <div >
                         
                        </div>
                      </div>
                      <div class="col">
                        <div >
                          
                        </div>
                      </div>
                      <div class="col">
                          <div >
                            <label class="font-semibold">Part/Serial No: </label><label>{{ item.partNo }}</label>
                          </div>
                      </div>                    
                    </div>
  
                    <div>
                      <Divider></Divider>
                    </div>
  
                    <div class="grid">
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Received Qty:</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            <label >{{ formatNumber(item.itemPackQty) }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Rate:</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            <label >{{ formatCurrency(item.itemRate) }}</label>
                          </div>
                      </div>
                    </div>
  
                    <div class="grid">
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">GST:</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            <label >{{ formatCurrency(item.gstAmt) }} ({{ formatNumber(item.gstPerc) }}%)</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Disc:</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            <label >{{ formatCurrency(item.discAmt) }} ({{ formatNumber(item.discPerc) }}%)</label>
                          </div>
                      </div>
                    </div>
  
                    <div class="grid">
                      <div class="col">                      
                          <div >
                            
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="text-lg font-semibold">Sub-Total:</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div class="text-right">
                            <label class="text-lg text-green-700">{{ formatCurrency(item.subTotal) }}</label>
                          </div>
                      </div>
                    </div> 
                    
  
                    <div v-if="item.equipmentPartsArr.length > 0 || item.batchArr.length > 0">
                      <Divider></Divider>
                    </div>
  
                    <!-- if batches present -->
                     <div v-if="item.batchArr.length>0">
                      <label class="font-semibold">Batch details:</label>
                     </div>
                    <div v-for="(item, index) in item.batchArr" :key="index" class="grid">
                      <div class="col">                      
                          <div >
                            {{ (index + 1) }}.<label class="font-semibold"> Quantity:</label> <label>{{ item.quantity }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Batch:</label> <label>{{ item.batch }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">MFG:</label> <label>{{ item.mfg }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">EXP:</label> <label>{{ item.exp }}</label>
                          </div>
                      </div>                             
                    </div>
  
  
                    <!-- if equipment parts present -->
                     <div v-if="item.equipmentPartsArr.length>0">
                      <label class="font-semibold">Parts details:</label>
                     </div>
                    <div v-for="(part, index) in item.equipmentPartsArr" :key="index" class="grid">
                      <div class="col">                      
                          <div >
                            {{ (index + 1) }}. <label class="font-semibold">Part:</label> <label>{{ part.part }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">HSN:</label> <label>{{ part.hsn }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Qty:</label> <label>{{ part.quantity }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Model:</label> <label>{{ part.model }}</label>
                          </div>
                      </div>
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Serial No.:</label> <label>{{ part.serial }}</label>
                          </div>
                      </div>  
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Rate.:</label> <label>{{ part.rate }}</label>
                          </div>
                      </div>  
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">GST(%):</label> <label>{{ part.gstRate }}</label>
                          </div>
                      </div>  
                      <div class="col">                      
                          <div >
                            <label class="font-semibold">Subtotal:</label> <label>{{ part.subtotal }}</label>
                          </div>
                      </div>                  
  
                    </div>
  
                  </Panel>
                </div>
                </ScrollPanel>

              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="sm:col-12 md:col-3 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 mx-3 ">
  
          <div class="mb-3">
            <label class="text-xl font-semibold">Item details</label>
          </div>
  
            <!-- <div class="formgrid grid"> -->
              <div class="field col">
                  <label >OEM</label>
                  <div>
                    <Dropdown class="w-full" v-model="selectedOem" filter :options="oems" optionValue="id" optionLabel="name" showClear placeholder="Select an OEM" @change="filterPendingItems"></Dropdown>
  
                  </div>
              </div>
              
            <!-- </div> -->
            <div class="field col">
              <DataTable v-model:filters="filters" v-model:selection="selectedItems" :value="filteredPendingItems" size="small" :loading="loading" @rowSelect="onRowSelect" @rowUnselect="onRowUnselect" showGridlines tableStyle="min-width: 10vw"  dataKey="index" paginator :rows="100" :rowsPerPageOptions="[100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30vh" stripedRows>
                
                <template #header >
                    <div class="flex flex-wrap align-items-center justify-content-end gap-2">
                        
                        <div class="flex justify-content-end">                            
                            <InputText v-model="filters['global'].value" placeholder="Keyword Search" size="small"/>
                        </div>
                        
                    </div>
                </template>
                <template #empty>
                  <div class="flex justify-content-center">
                    <span class="text-gray-500 font-semibold">No data. Select OEM for pending items.</span>
                  </div>
                </template>


                <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                <Column field="item_name" header="Item"></Column>
                <Column field="quantity" header="Quantity">
                  <template #body="slotProps">
                    {{ formatNumber(slotProps.data.quantity) }}
                  </template>
                </Column>
                <Column field="arrived.quantity" header="Dispatched Qty">
                    <template #body="slotProps">
                      {{ formatNumber(slotProps.data.arrived.quantity) }}
                    </template>
                </Column>

                <!-- <Column field="cost" header="Cost"></Column>
                <Column field="tax" header="Tax"></Column> -->
              </DataTable>
            </div>
        </div>
      </div>

    </div>



    <!-- </div> -->
  </div>
</template>

<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Divider from 'primevue/divider';
import InputText from 'primevue/inputtext';
import InvoiceItemTwo from '../invoice/invoiceItemTwo.vue'
import { createInvoice, getManufacturers, itemsPendingInvoice } from '@/services/apiService';
import Dropdown from 'primevue/dropdown';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Panel from 'primevue/panel';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import ScrollPanel from 'primevue/scrollpanel';
import ProgressSpinner from 'primevue/progressspinner';
import { FilterMatchMode } from 'primevue/api'

export default {
  components:{
    Button,
    InputText,
    Calendar,
    Divider,
    InvoiceItemTwo,
    Dropdown,
    DataTable,
    Column,
    Panel,
    InputNumber,
    Textarea,
    ScrollPanel,
    ProgressSpinner,
  },
  data(){
    return{
      invoiceNo:null,
      invoiceDate:null,
      items:[],
      newItemDialog:false,
      selectedItem: null,
      pendingItems:[],
      filteredPendingItems:[],
      loading: false,
      oems:[],
      selectedOem: null,
      selectedItems: [],
      invoiceItems:[],
      freight: 0,
      remarks:null,
      taxable:0.0,
      invoiceGst:0,
      invoiceDiscount:0,
      invoiceValue:0,
      spinnerLoadingStatus: false,
      filters:{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                item_name: { value: null, matchMode: FilterMatchMode.IN },
            },
    }
  },
  mounted(){
    
    this.fetchManufacturers();
    this.fetchPendingItems();
  },
  methods: {
    fetchManufacturers(){
      getManufacturers().then((res)=>{
        this.oems = res.data;
      }).catch((error)=>{
          this.showErrorToast(error.response.data);
      });
    },
    async fetchPendingItems(){
      this.loading = true;
      this.filteredPendingItems = [];
      this.pendingItems = [];
      try {
        const response = await itemsPendingInvoice();
        this.pendingItems = response.data;
        this.loading = false;
      } catch (error) {
        this.showErrorToast(error.response.data);
        this.loading = false;
      }
    },
    addItem(item) {

      this.items.push(item);
      this.newItemDialog = true;
    },
    filterPendingItems(){

      if(this.selectedOem==null){
        return this.clearUi();
      }

      let index = 0;
      this.filteredPendingItems = [];
      this.pendingItems.forEach(e => {        
        
        if(e.oem_po.uuid === this.selectedOem){
          e.arrived.forEach(el => {
              if(el.invoiceStatus==0){
                  this.filteredPendingItems.push({
                      ...e,
                      index:index++,
                      item_name2:e.item_name,
                      arrived:el,
                      manufacturer:e.oem_po,
                  });
              }
          });
        }
        
      });
    },
    saveItem(item){
      this.invoiceItems.push(item)
      this.newItemDialog = false; 
      this.calculateInvoiceValue(null);    
    },
    showNewItemDialog(){
      this.newItemDialog = true;
    },
    closeDialog(visible, itemId){
      this.newItemDialog = visible;
      this.selectedItems = this.selectedItems.filter(item => item.id !== itemId);      
    },
    showErrorToast(error){
      this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
    },
    onRowSelect(event){
      this.addItem(event.data);
    },
    formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },
    formatNumber(value) {
            return value.toLocaleString('en-IN');
    },
    onRowUnselect(event){      
      this.invoiceItems = this.invoiceItems.filter(item => item.itemId !== event.data.id);
      this.selectedItems = this.selectedItems.filter(item => item.id !== event.data.id);
      this.calculateInvoiceValue(null);
    },
    calculateInvoiceValue(event){      
        this.taxable = 0;
        this.invoiceGst = 0;
        this.invoiceDiscount = 0;
        this.invoiceValue = 0;

        this.invoiceItems.map((item)=>{
          this.taxable += item.amount;
          this.invoiceGst += item.gstAmt;
          this.invoiceDiscount  += item.discAmt;
        });
        
        this.invoiceValue += (this.taxable + this.invoiceGst);
        if(event){
          this.invoiceValue += event.value;
        }

    },
    saveInvoice(){
      if(this.invoiceNo==null || this.invoiceDate==null){
        this.showErrorToast({message:'Invoice No. and Invoice date is required.'});
        return;
      }

      if(this.invoiceItems.length==0){
        this.showErrorToast({message:'Please add items to invoice.'});
        return;
      }

      this.spinnerLoadingStatus = true;
      const itemsTemp = this.invoiceItems;

      let payload = [];

      itemsTemp.map((item)=>{
        if(item.batchArr.length > 0){
          item.batchArr.map((e)=>{
            payload.push({
              stockArrId:item.stockArrId,
              itemId:item.itemId,
              itemHsn:item.itemHsn,
              name:item.name,
              packing:item.packing,
              batchNo:e.batch,
              itemPackQty:e.quantity,
              mfgDate:e.mfg,
              expDate:e.exp,
              itemRate:e.rate,
              gstPerc:e.gstRate,
              gstAmt:(e.rate * e.quantity)*(e.gstRate/100),
              partNo:null,
              modelNo:null,
              discPerc:e.discPerc,
              discAmt:e.discAmt,
              amount:(e.rate * e.quantity),
              subTotal:e.subTotal,
              equipmentPartsArr:[],
              batchArr:[],
            });
          });
        }
        if(item.batchArr.length==0){
          payload.push({
            stockArrId:item.stockArrId,
            itemId:item.itemId,
            itemHsn:item.itemHsn,
            name:item.name,
            packing:item.packing,
            batchNo:item.batchNo,
            itemPackQty:item.itemPackQty,
            mfgDate:null,
            expDate:null,
            itemRate:item.itemRate,
            gstPerc:item.gstPerc,
            gstAmt:(item.itemRate * item.itemPackQty)*(item.gstPerc/100),
            partNo:item.partNo,
            modelNo:item.modelNo,
            discPerc:item.discPerc,
            discAmt:item.discAmt,
            amount:(item.itemRate * item.itemPackQty),
            subTotal:item.subTotal,
            equipmentPartsArr:[...item.equipmentPartsArr],
            batchArr:[],
          });
        }
      });

      const data = {
          // 'oemPoId':this.selectedOemPo.id,
          'oem':this.selectedOem,
          'invoiceNo':this.invoiceNo,
          'invoiceDate':this.invoiceDate.getFullYear()+'-'+(this.invoiceDate.getMonth()+1)+'-'+this.invoiceDate.getDate(),
          'invoiceItems':payload,
          'taxable':this.taxable,
          'totalDiscount':this.invoiceDiscount,
          'totalGst':this.invoiceGst,
          'freight':this.freight,
          'totalInvoiceValue':this.invoiceValue,
          'remarks':this.remarks,
      }
      

      createInvoice(data).then((res)=>{
        this.showSuccessToast(res.data);
        this.fetchPendingItems();
        this.clearUi();
        this.spinnerLoadingStatus = false;
        this.$router.push({ name:'invoice-details'});
      }).catch((error)=>{
        this.showErrorToast(error.response.data);
        this.spinnerLoadingStatus = false;
      });
      
    },
    convertToUpperCase(event){
      if(event.target.value){
        this.invoiceNo = event.target.value.toUpperCase();
      }
    },
    showSuccessToast(data){
        this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
    },
    clearUi(){
      this.invoiceNo = null;
      this.invoiceDate = null;
      this.freight = 0.0;
      this.remarks = null;
      this.taxable = 0.0;
      this.invoiceGst = 0.0;
      this.invoiceDiscount = 0.0;
      this.invoiceValue = 0.0;
      this.invoiceItems = [];
      this.selectedOem = null;
      this.selectedItems = [];
      this.filteredPendingItems = [];
    },

  }
}
</script>

<style>

</style>